module.exports = __webpack_public_path__ + "img/food-network.19ee88db.svg";